import React from 'react';
import { useTranslation } from 'react-i18next';
import DownloadIcon from './icons/DownloadIcon';
import DownloadFormatCombo from './DownloadFormatCombo.jsx';
import Grid from '@mui/material/Grid';
import { getDownloadFormat } from '../utils/sessionStorage.js';
import { trackActivity } from '../utils/custom-track-events.js';
import {
    LegacyCertificateTrackAction as CertificateTrackAction,
    LegacyTrackCategory as TrackCategory,
} from '@pok/viewer-api-sdk';
import { registerEvent } from '../utils/google-analytics.js';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { downloadEdciFile, downloadPdfFile } from '../utils/download.js';
import { currentLanguage } from '@pok/weblib/build/ui/language.js';
import { useLoading } from '@pok/weblib/context/loading-context.jsx';
import { supportedLocale } from '@pok/weblib';
import { LoadOrganization } from '../utils/queries.js';

export default function CertificateDownload({ certificate, img, disabled, color, onExpiredToken }) {
    const { t, i18n } = useTranslation();
    const { showLoading, hideLoading } = useLoading();
    const organization = LoadOrganization(certificate.minter).data;
    const handleDownloadClick = async (e) => {
        switch (getDownloadFormat(certificate.id, undefined)) {
            case 'png':
                downloadImage(organization.name).then();
                break;
            case 'pdf':
                showLoading();
                downloadPdfFile(
                    certificate.id,
                    supportedLocale(currentLanguage(undefined, i18n.language)),
                    certificate.image,
                    certificate.minter,
                    onExpiredToken,
                    organization,
                ).then(() => hideLoading());
                break;
            case 'europass':
                downloadEdciFile(
                    certificate.id,
                    certificate.image,
                    certificate.minter,
                    onExpiredToken,
                    organization,
                ).then();
                break;
        }
    };

    const downloadImage = async (name) => {
        const d = document.createElement('a');
        d.href = img;
        d.download = `${name}.png`;
        d.target = '_blank';
        d.click();
        registerEvent('img_download');
        trackActivity(
            TrackCategory.CERTIFICATE,
            CertificateTrackAction.DOWNLOAD_IMAGE,
            certificate.id,
            certificate.minter,
        ).then();
    };

    const downloadButton = (
        <Button
            variant="outlined"
            sx={{
                padding: 1,
                width: '100%',
                borderColor: color,
                color: color,
                '&:hover': {
                    borderColor: color,
                },
            }}
            disabled={disabled}
            onClick={handleDownloadClick}
        >
            <Grid container>
                <Grid item xs={8.5}>
                    <Stack direction={'row'} justifyContent={'center'}>
                        <Stack>
                            <DownloadIcon fill={disabled ? '#D9D9D9' : color} sx />
                        </Stack>
                        <Stack marginLeft={2}>{t('certificate.download')}</Stack>
                    </Stack>
                </Grid>
                <Grid item xs={3.5}>
                    <DownloadFormatCombo certificateId={certificate.id} wallet={undefined} disabled={disabled} />
                </Grid>
            </Grid>
        </Button>
    );

    return <>{downloadButton}</>;
}
